// Query params that can carry one-time secrets in this app's URLs, e.g. /change-password?token=...
// and /sign-up/?invite=<encoded_invite_id>. Shared by anything that sends or logs a URL
// (PostHog, HubSpot tracking, console output) so a new leak point can't drift out of sync.
const SENSITIVE_URL_PARAMS = ['token', 'invite', 'password', 'secret', 'auth', 'key', 'code'];

const redactSensitiveUrlParams = (value: string): string => {
  try {
    const url = new URL(value, window.location.origin);
    if (!SENSITIVE_URL_PARAMS.some(param => url.searchParams.has(param))) return value;
    SENSITIVE_URL_PARAMS.forEach(param => url.searchParams.has(param) && url.searchParams.set(param, '[redacted]'));
    // Preserve relative-vs-absolute shape of the input instead of always returning an absolute URL.
    return value.startsWith('/') ? url.pathname + url.search : url.toString();
  } catch {
    return value;
  }
};

export {SENSITIVE_URL_PARAMS, redactSensitiveUrlParams};
